import { Box, Link } from "@mui/material";

const Footer = ({style}) =>
{
    return(
        <div style={style}>
            <Box>
                <Link className="custom-button-root custom-link-root" href='impressum'>Impressum</Link>
                <Link className="custom-button-root custom-link-root" href='datenschutzerklaerung'>Datenschutzerklärung</Link>
            </Box>
        </div>
    );
}

export default Footer;
